<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="800" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="text-body-1 text-sm-h6">
					<span class="black--text text-uppercase font-weight-bold">Riwayat Upload</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
			 
				</v-card-text>
				<v-card-actions>
					<v-col cols="12" class="text-center">
						<v-btn depressed color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg" @click="confirm">Konfirmasi</v-btn>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
	data () {
		return {
			dialog: false,
			bank: [
			{ name: 'Bank BCA', norek: '456 789 1410', img: '/assets/bank/bca.svg' },
			],
			selectedBank: {},
			min_transfer: 0,
			formData: new FormData(),
			image: '',
			bank_from:'',
			sender_name: '',
			is_top:'0',
			sender_number: '',
			sending_value: '',
			note: '',
		}
	},
	computed: {
		...mapState('options', ['listBank', 'bankAccountList']),
		...mapState('transaction', ['responseError']),
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		modalShow(bank, min_transfer,is_top) {
			console.log(is_top)
			this.is_top = is_top
			this.sending_value = min_transfer
			this.dialog = true
			this.selectedBank = bank
			this.min_transfer = min_transfer
		},
		modalHide() {
			this.dialog = false
		},
		async confirm() {
			if(this.is_top == '0'){
				await this.formData.append('bank_account_id', this.selectedBank.bank_account_id);
				// await this.formData.append('bank_branch', this.bank_from.);
				await this.formData.append('bank_account_name', this.sender_name);
				await this.formData.append('bank_account_number', this.sender_number);
				await this.formData.append('transfer_value', this.sending_value);
				await this.formData.append('bank_name', this.bank_from);
				await this.formData.append('note', this.note);
				await this.$emit('action', this.formData) 
			}else{
				await this.formData.append('bank_account_id', this.selectedBank.bank_account_id); 
				await this.formData.append('note', this.note);
				await this.$emit('action', this.formData)
			}
		},
		async openUpload() {
			const input = await document.getElementById('inputImage')
			input.click()
		},
		handleFileUpload(event) {
			this.formData.append('image', event);

			if (!event)
				return;

			this.createImage(event);
		},
		createImage(file) {
			var reader = new FileReader();

			reader.onload = (e) => {
				this.image = e.target.result;
			};
			reader.readAsDataURL(file);
		},
	},
};
</script>